var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "gantt-filter", attrs: { type: "flex" } },
    [
      _c(
        "el-col",
        { staticClass: "filter-container", attrs: { span: 24 } },
        [
          _c(
            "el-form",
            {
              attrs: {
                "label-position": "top",
                "label-width": "8em",
                inline: true,
                size: "mini",
              },
            },
            [
              _vm.isDashboard
                ? _c(
                    "el-form-item",
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": _vm.$t("planning.autoScrolling"),
                        },
                        on: { change: _vm.handleAutoScrollingChange },
                        model: {
                          value: _vm.isAutoScrolling,
                          callback: function ($$v) {
                            _vm.isAutoScrolling = $$v
                          },
                          expression: "isAutoScrolling",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { staticStyle: { "min-width": "250px" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      attrs: {
                        multiple: "",
                        clearable: "",
                        placeholder: _vm.$t("planning.columns.projectCode"),
                      },
                      model: {
                        value: _vm.$selectedProjects,
                        callback: function ($$v) {
                          _vm.$selectedProjects = $$v
                        },
                        expression: "$selectedProjects",
                      },
                    },
                    _vm._l(_vm.$projectCodes, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.ProjectCode,
                          value: item.ProjectCode,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticStyle: { "min-width": "250px" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      attrs: {
                        multiple: "",
                        clearable: "",
                        placeholder: _vm.$t("planning.columns.customer"),
                      },
                      model: {
                        value: _vm.$selectedCustomers,
                        callback: function ($$v) {
                          _vm.$selectedCustomers = $$v
                        },
                        expression: "$selectedCustomers",
                      },
                    },
                    _vm._l(_vm.$customers, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.CustName, value: item.CustCode },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticStyle: { "min-width": "250px" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      attrs: {
                        multiple: "",
                        clearable: "",
                        placeholder: _vm.$t("planning.columns.truck"),
                      },
                      model: {
                        value: _vm.$selectedTrucks,
                        callback: function ($$v) {
                          _vm.$selectedTrucks = $$v
                        },
                        expression: "$selectedTrucks",
                      },
                    },
                    _vm._l(_vm.$trucks, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.PlateNum, value: item.RecId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticStyle: { "min-width": "230px" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      attrs: {
                        multiple: "",
                        clearable: "",
                        placeholder: _vm.$t("planning.alertType"),
                      },
                      model: {
                        value: _vm.alertType,
                        callback: function ($$v) {
                          _vm.alertType = $$v
                        },
                        expression: "alertType",
                      },
                    },
                    _vm._l(["normal", "yellow", "red"], function (item) {
                      return _c("el-option", {
                        key: item,
                        attrs: {
                          label: _vm.$t("general." + item),
                          value: item,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.getData } },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: "search",
                          "aria-hidden": "true",
                          size: "sm",
                        },
                      }),
                      _c("span", { staticClass: "ml-1" }, [
                        _vm._v(_vm._s(_vm.$t("general.search"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }